import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getHighlight } from "../Service/Api";
import { Link } from "react-router-dom";

const Highlights = () => {
  // React Query handles loading, error, and data states automatically
  const {
    data = [],
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ["highlights"],
    queryFn: getHighlight,
  });

  // Default placeholder data
  const emptyData = [
    { id: 1, title: "Stay Tuned For More Updates" },
    { id: 2, title: "Stay Tuned For More Updates" },
    { id: 3, title: "Stay Tuned For More Updates" },
  ];

  // Loading state
  if (isLoading) {
    return (
      <div className="highlights text-center">
        <p>Loading highlights...</p>
      </div>
    );
  }

  // Error state
  if (isError) {
    console.error(error);
  }

  // Choose what to render
  const highlightsToRender = data && data.length > 0 ? data : emptyData;

  return (
    <div className="highlights">
      <marquee
        onMouseOver={(event) => event.currentTarget.stop()}
        onMouseOut={(event) => event.currentTarget.start()}
      >
        {highlightsToRender.map((item, index) => (
          <p key={index}>
            <Link
              to={
                item.attachments && item.attachments.length > 0
                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                  : "#"
              }
              target="_blank"
            >
              {item.title} <i className="bi bi-paperclip"></i>
            </Link>{" "}
            |
          </p>
        ))}
      </marquee>
    </div>
  );
};

export default Highlights;
